import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form } from 'semantic-ui-react'

import SemanticUiModal from './semantic_ui_modal';
import ScopeAndContextReasonsTable from './scope_and_context_reasons_table';

import 'semantic-ui-css/semantic.min.css';
import '../App.css';

function ScopeAndContextActions(props) {
  const {hideScopeAndContextModal, saveScopeAndContext, translations, permission} = props;
  const disabled = permission.can_update ? false : true;
  return (
    <div>
      <Button size='medium' className="close-button" onClick={hideScopeAndContextModal}>
        {translations.cancel}
      </Button>
      <Button disabled={disabled} positive size='medium' className="save-scope-and-context-button" onClick={saveScopeAndContext}>
        {translations.save}
      </Button>
    </div>
  )
}

function ScopeAndContextForm(props) {
  const { plan, handleScopeChange, handleContextChange, translations, permission } = props;
  const disabled = permission.can_update ? false : true;
  return (
    <Form className="scope-and-context-form">
      <Form.Field>
        <label>{translations.scope}</label>
        <textarea disabled={disabled} name='scope' placeholder={translations.scope_description} defaultValue={plan.scope} onChange={handleScopeChange}/>
      </Form.Field>
      <Form.Field>
        <label>{translations.context}</label>
        <textarea disabled={disabled} name='context' placeholder={translations.context_description} defaultValue={plan.context} onChange={handleContextChange}/>
      </Form.Field>
    </Form>
  )
}

class ScopeAndContextModal extends Component {
  constructor(props){
    super(props);

    this.state = {
      plan: {...props.plan }
    }
  }

  handleInputChange = (evt) => {
    const { plan } = this.state;
    plan[evt.target.name] = evt.target.value;
    this.setState({ plan });
  }

  addNewReson = () => {
    const { plan } = this.state;
    const newReason = {
      date: "",
      reason_for_update: "",
      key_factors: "",
      author: "",
    };
    if(!plan.reason_for_update_logs) {
      plan.reason_for_update_logs = [];
    }
    plan.reason_for_update_logs.unshift(newReason);
    this.setState({ plan });
  }

  handleReasonChange = (evt, logIndex) => {
    const { plan } = this.state;
    plan.reason_for_update_logs[logIndex][evt.target.name] = evt.target.value;
    this.setState({ plan });
  }

  saveScopeAndContext = () => {
    this.props.saveScopeAndContext(this.state.plan);
  }

  render() {
    const modalOptions = { className: "scope-and-context-modal", size: "tiny" }
    return (
      <SemanticUiModal
        modalOptions={modalOptions}
        header={'Scope & Context'}
        content={
          <React.Fragment>
            <ScopeAndContextForm
              plan={this.state.plan}
              handleScopeChange={this.handleInputChange}
              handleContextChange={this.handleInputChange}
              translations={this.props.translations}
              permission={this.props.permission}
            />
            <br />
            <ScopeAndContextReasonsTable
              data={this.state.plan.reason_for_update_logs || []} 
              addNewReson={this.addNewReson}
              handleReasonChange={this.handleReasonChange}
              permission={this.props.permission}
            />
        </React.Fragment>
        }
        actions={
          <ScopeAndContextActions
            hideScopeAndContextModal={this.props.hideScopeAndContextModal}
            saveScopeAndContext={this.saveScopeAndContext}
            translations={this.props.translations}
            permission={this.props.permission}
          />
        }
        closeModal={this.props.hideScopeAndContextModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.language.language.translations
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ScopeAndContextModal);


// WEBPACK FOOTER //
// ./src/components/scope_and_context_modal.js